
import { Answer } from '../Diagnosis'

type DiagnosisChoiceProps = {
	choice: Answer;
	onAnswerSelected: (choice: Answer) => void;
}

const DiagnosisChoice = (props: DiagnosisChoiceProps) => {
	return (
		<div className="form-group">
			<input className="form-check-input" type="checkbox" name="exampleRadios" id={`radio_${props.choice.id}`} value="option1" style={{ display: 'none' }}
				onClick={() => props.onAnswerSelected(props.choice)} checked={false} />
			<label className="form-check-label btn btn-outline-secondary" htmlFor={`radio_${props.choice.id}`} >
				{props.choice.answer}
			</label>
		</div>
	);
};

export { DiagnosisChoice };
